import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getVoiceFlow = asyncThunkWrapper({ 
  model: 'voiceFlow', 
  action: 'getVoiceFlow', 
  func: async () => {
    const attributes = ['id', 'phone', 'email', 'prompt', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/voice_flow`, { params });

    return response.data;
  } 
});
export const createVoiceFlow = asyncThunkWrapper({ 
  model: 'voiceFlow', 
  action: 'createVoiceFlow', 
  func: async (voice_flow) => {
    const attributes = ['id', 'phone', 'email', 'prompt', 'updated_at'];
    const response = await axios.post(`/voice_flow`, { voice_flow, attributes });

    return response.data;
  } 
});
export const updateVoiceFlow = asyncThunkWrapper({ 
  model: 'voiceFlow', 
  action: 'updateVoiceFlow', 
  func: async (voice_flow) => {
    const response = await axios.patch(`/voice_flow`, { voice_flow });

    return { status: response.status, voice_flow };
  } 
});
export const deleteVoiceFlow = asyncThunkWrapper({ 
  model: 'voiceFlow', 
  action: 'deleteVoiceFlow', 
  func: async () => {
    const response = await axios.delete(`/voice_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveVoiceFlow = createAction('voiceFlow/clearLocalActiveVoiceFlow');